import React, { useEffect, useState } from "react";
import useFinanceStore from "modules/financial_dashboard/store";
import CardDiv from "modules/common/card-div/CardDiv";
import FinancialGraph from "modules/financial_dashboard/FinancialGraph";
import { fourPlaceHolder } from "modules/utilities/utility";
import moment from "moment";
import DatePicker from "react-datepicker";
import FinancialData from "modules/financial_dashboard/FinancialData";
import FinancialOrderData from "modules/financial_dashboard/FinancialOrderData";
import { isEmpty } from "lodash";
import Flex from "modules/common/Flex";
import { Form } from "react-bootstrap";
import FinancialTable from "modules/financial_dashboard/FinancialTable";
import BarGraph from "./BarGraph";
import BarGraphColumn from "./BarGraphColumn";

function FinancialDashboard() {
  const {
    financeData,
    cancelData,
    rtoData,
    isLoading,
    cancelLoading,
    rtoLoading,
    fetchFinanceData,
    fetchCancelData,
    fetchRtoData,
  } = useFinanceStore();
  const [selectedGraphKey, setSelectedGraphKey] = useState("totalOrdersSum");
  const [selectedCountKey, setSelectedCountKey] = useState("totalOrdersCount");
  const currentDate = new Date();
  const [compStartDate, setCompStartDate] = useState(
    currentDate.getTime() - 24 * 60 * 60 * 1000
  );
  const [endLastDate, setEndDate] = useState(currentDate);
  const [prevCompDate, setPrevCompDate] = useState(
    currentDate.getTime() - 24 * 60 * 60 * 1000
  );
  const [prevLastDate, setPrevLastDate] = useState(currentDate);
  const [submitFlag, setSubmitFlag] = useState(0);
  const [currentHour, setCurrentHour] = useState(null);
  const [selectedTab, setSelectedTab] = useState("sales");
  const [tableFlag, setTableFlag] = useState(false);
  const [barGraphFLag, setBarGraphFlag] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    web_shopify: true,
    web_native: true,
    crm: true,
    app_shopflo: true,
    app_juspay: true,
  });

  const handleCheckboxToggle = (checkboxId) => {
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [checkboxId]: !prevCheckboxes[checkboxId],
    }));
  };

  useEffect(() => {
    const now = moment();
    const hour = now.format("H");

    setCurrentHour(hour);
  }, []);


  useEffect(() => {
    const startDate = moment(endLastDate).startOf("day").toISOString();
    const endDate = moment(endLastDate).endOf("day").toISOString();
    const compareStartDate = moment(compStartDate)
      .startOf("days")
      .toISOString();
    const compareEndDate = moment(compStartDate).endOf("day").toISOString();
    if (selectedTab == "sales") {
      fetchFinanceData({
        startDate: startDate,
        endDate: endDate,
        compareStartDate: compareStartDate,
        compareEndDate: compareEndDate,
      });
    } else if (selectedTab == "cancel") {
      fetchCancelData({
        startDate: startDate,
        endDate: endDate,
        compareStartDate: compareStartDate,
        compareEndDate: compareEndDate,
        category: "cancelled",
      });
    } else if (selectedTab == "rto") {
      fetchRtoData({
        startDate: startDate,
        endDate: endDate,
        compareStartDate: compareStartDate,
        compareEndDate: compareEndDate,
        category: "rto",
      });
    }
  }, [submitFlag, selectedTab]);

  const dataMapping = {
    sales: financeData,
    rto: rtoData,
    cancel: cancelData,
  };

  const loadingMap = {
    sales: isLoading,
    rto: rtoLoading,
    cancel: cancelLoading,
  };
  const totalMap = {
    sales: "Revenue",
    rto: "Rto",
    cancel: "Cancel",
  };

  const handleClear = () => {
    const currentDate = new Date();
    setCompStartDate(currentDate.getTime() - 24 * 60 * 60 * 1000);
    setPrevCompDate(currentDate.getTime() - 24 * 60 * 60 * 1000);
    setPrevLastDate(currentDate);
    setEndDate(currentDate);
    setSubmitFlag(submitFlag + 1);
  };

  const handleSubmit = () => {
    setSubmitFlag(submitFlag + 1);
  };

  const extractTotalSum = (data, target, graphKey) => {
    const totalSums = {
      web_shopify: 0,
      web_native: 0,
      crm: 0,
      app_shopflo: 0,
      app_juspay: 0,
    };

    for (const day in data[target]) {
      if (
        Number(currentHour) + 1 <= Number(day) &&
        prevLastDate === endLastDate
      ) {
        break;
      }
      const dayData = data[target][day];
      for (const category in totalSums) {
        // const totalSum = dayData[category][graphKey]||0;
        const totalSum =
          (dayData[category] && dayData[category][graphKey]) || 0;
        totalSums[category] += totalSum;
      }
    }
    return totalSums;
  };

  const handleTab = (tab) => {
    setSelectedTab(tab);
    setTableFlag(false);
  };

  const totalTodaySums = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "totalOrdersSum"
  );
  const totalYesterdaySums = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "totalOrdersSum"
  );
  const totalMaleTodaySums = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "maleOrdersSum"
  );

  const totalMaleYesterdaySums = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "maleOrdersSum"
  );
  //new and repeat
  const totalNewMaleTodaySums = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "maleNewOrderSum"
  );

  const totalNewMaleYesterdaySums = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "maleNewOrderSum"
  );
  //
  const totalRepeatMaleTodaySums = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "maleRepeatOrderSum"
  );

  const totalRepeatMaleYesterdaySums = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "maleRepeatOrderSum"
  );
  //female repeat
  const totalNewFemaleTodaySums = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "femaleNewOrderSum"
  );

  const totalNewFemaleYesterdaySums = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "femaleNewOrderSum"
  );
  //
  const totalRepeatFemaleTodaySums = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "femaleRepeatOrderSum"
  );

  const totalRepeatFemaleYesterdaySums = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "femaleRepeatOrderSum"
  );
  //
  //end of female repeat
  const totalFemaleTodaySums = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "femaleOrdersSum"
  );
  const totalFemaleYesterdaySums = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "femaleOrdersSum"
  );
  const totalNewTodaySums = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "newOrdersOrdersSum"
  );
  const totalNewYesterdaySums = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "newOrdersOrdersSum"
  );
  const totalRepeatTodaySums = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "repeatOrdersSum"
  );
  const totalRepeatYesterdaySums = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "repeatOrdersSum"
  );

  const totalTodayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "totalOrdersCount"
  );
  const totalYesterdayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "totalOrdersCount"
  );
  const totalMaleTodayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "maleOrdersCount"
  );
  const totalMaleYesterdayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "maleOrdersCount"
  );
  const totalFemaleTodayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "femaleOrdersCount"
  );
  const totalFemaleYesterdayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "femaleOrdersCount"
  );
  const totalNewTodayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "newOrdersCount"
  );
  const totalNewYesterdayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "newOrdersCount"
  );
  const totalRepeatTodayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "repeatOrdersCount"
  );
  const totalRepeatYesterdayCountSum = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "repeatOrdersCount"
  );
  // here after another count
  const totalNewMaleNewTodayCount = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "maleNewOrderCount"
  );
  const totalNewMaleYesterdayCount = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "maleNewOrderCount"
  );
  const totalRepeatMaleNewTodayCount = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "maleRepeatOrderCount"
  );
  const totalRepeatMaleYesterdayCount = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "maleRepeatOrderCount"
  );
  const totalFemaleNewTodayCount = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "femaleNewOrdersCount"
  );
  const totalNewFemaleYesterdayCount = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "femaleNewOrdersCount"
  );
  const totalFemaleRepeatTodayCount = extractTotalSum(
    dataMapping[selectedTab],
    "today",
    "femaleRepeatOrderCount"
  );
  const totalFemaleRepeatYesterdayCount = extractTotalSum(
    dataMapping[selectedTab],
    "yesterday",
    "femaleRepeatOrderCount"
  );

  const amount = (varName) => {
    const sum =
      (checkboxes.crm ? varName?.crm : 0) +
      (checkboxes.app_shopflo ? varName?.app_shopflo : 0) +
      (checkboxes.app_juspay ? varName?.app_juspay : 0) +
      (checkboxes.web_shopify ? varName?.web_shopify : 0) +
      (checkboxes.web_native ? varName?.web_native : 0);
    return sum;
  };
  const subAmount = (varName) => {
    const sum =
      (checkboxes.crm ? varName?.crm : 0) +
      // (checkboxes.app ? varName?.app : 0) +
      (checkboxes.app_shopflo ? varName?.app_shopflo : 0) +
      (checkboxes.app_juspay ? varName?.app_juspay : 0) +
      (checkboxes.web_shopify ? varName?.web_shopify : 0) +
      (checkboxes.web_native ? varName?.web_native : 0);
    return sum;
  };

  const calculatePercentage = (todayResponse, yesterdayResponse) => {
    const todayResponseSum = amount(todayResponse);
    const yesterdayResponseSum = amount(yesterdayResponse);
    let returnSum = 0;
    if (todayResponseSum > yesterdayResponseSum) {
      returnSum =
        ((todayResponseSum - yesterdayResponseSum) / yesterdayResponseSum) *
        100;
    } else if (todayResponseSum < yesterdayResponseSum) {
      returnSum =
        ((yesterdayResponseSum - todayResponseSum) / yesterdayResponseSum) *
        100;
    } else {
      returnSum = 0;
    }
    return returnSum.toFixed(2);
  };

  const saleItems = [
    {
      //total sum
      title: `Total ${totalMap[selectedTab]}`,
      amount: amount(totalTodaySums),
      subAmount: subAmount(totalYesterdaySums),
      type: "standard",
      percent: calculatePercentage(totalTodaySums, totalYesterdaySums),
      className:
        selectedGraphKey === "totalOrdersSum"
          ? "border-200 border-bottom pb-2"
          : "border-200 border-bottom pb-2",
      totalGraphKey: "totalOrdersSum",
      newGraphKey: "newOrdersOrdersSum",
      repeatGraphKey: "repeatOrdersSum",
      totalCountKey: "totalOrdersCount",
      newCountKey: "newOrdersCount",
      repeatCountKey: "repeatOrdersCount",
      // New order sum
      newAmount: amount(totalNewTodaySums),
      newSubAmount: subAmount(totalNewYesterdaySums),
      type: "standard",
      newPercent: calculatePercentage(totalNewTodaySums, totalNewYesterdaySums),
      //Repeat Order sum
      repeatAmount: amount(totalRepeatTodaySums),
      repeatSubAmount: subAmount(totalRepeatYesterdaySums),
      type: "standard",
      repeatPercent: calculatePercentage(
        totalRepeatTodaySums,
        totalRepeatYesterdaySums
      ),
      //Total Order Count
      totalCount: amount(totalTodayCountSum),
      totalSubCount: subAmount(totalYesterdayCountSum),
      type: "standard",
      totalPercent: calculatePercentage(
        totalTodayCountSum,
        totalYesterdayCountSum
      ),
      // total New order count
      newCount: amount(totalNewTodayCountSum),
      newSubCount: subAmount(totalNewYesterdayCountSum),
      type: "standard",
      newPercentCount: calculatePercentage(
        totalNewTodayCountSum,
        totalNewYesterdayCountSum
      ),
      // total New repeat order count
      repeatCount: amount(totalRepeatTodayCountSum),
      repeatSubCount: subAmount(totalRepeatYesterdayCountSum),
      type: "standard",
      repeatPercentCount: calculatePercentage(
        totalRepeatTodayCountSum,
        totalRepeatYesterdayCountSum
      ),
      newFlag: true,
    },
    {
      title: `Male ${totalMap[selectedTab]}`,
      amount: amount(totalMaleTodaySums),
      subAmount: subAmount(totalMaleYesterdaySums),
      type: "standard",
      percent: calculatePercentage(totalMaleTodaySums, totalMaleYesterdaySums),
      className:
        selectedGraphKey === "maleOrdersSum"
          ? "border-200 border-md-200 border-bottom pb-2 pt-2 ps-3"
          : "border-200 border-md-200 border-bottom pb-2 pt-2 ps-3",
      totalGraphKey: "maleOrdersSum",
      newGraphKey: "maleNewOrderSum",
      repeatGraphKey: "maleRepeatOrderSum",
      totalCountKey: "maleOrdersCount",
      newCountKey: "maleNewOrderCount",
      repeatCountKey: "maleRepeatOrderCount",
      // graphKey: "maleOrdersSum",
      // countKey: "maleOrdersCount",
      // New count sum
      newAmount: amount(totalNewMaleTodaySums),
      newSubAmount: subAmount(totalNewMaleYesterdaySums),
      newPercent: calculatePercentage(
        totalNewMaleTodaySums,
        totalNewMaleYesterdaySums
      ),
      // repeat count sum
      repeatAmount: amount(totalRepeatMaleTodaySums),
      repeatSubAmount: subAmount(totalRepeatMaleYesterdaySums),
      repeatPercent: calculatePercentage(
        totalRepeatMaleTodaySums,
        totalRepeatMaleYesterdaySums
      ),

      //New count count
      totalCount: amount(totalMaleTodayCountSum),
      totalSubCount: subAmount(totalMaleYesterdayCountSum),
      type: "standard",
      totalPercent: calculatePercentage(
        totalMaleTodayCountSum,
        totalMaleYesterdayCountSum
      ),
      // new order
      newCount: amount(totalNewMaleNewTodayCount),
      newSubCount: subAmount(totalNewMaleYesterdayCount),
      newPercentCount: calculatePercentage(
        totalNewMaleNewTodayCount,
        totalNewMaleYesterdayCount
      ),
      // Repeat
      repeatCount: amount(totalRepeatMaleNewTodayCount),
      repeatSubCount: subAmount(totalRepeatMaleYesterdayCount),
      repeatPercentCount: calculatePercentage(
        totalRepeatMaleNewTodayCount,
        totalRepeatMaleYesterdayCount
      ),
      newFlag: true,
    },
    {
      title: `Female ${totalMap[selectedTab]}`,
      amount: amount(totalFemaleTodaySums),
      subAmount: subAmount(totalFemaleYesterdaySums),
      type: "standard",
      percent: calculatePercentage(
        totalFemaleTodaySums,
        totalFemaleYesterdaySums
      ),
      className:
        selectedGraphKey === "femaleOrdersSum"
          ? "border-200 border-md-200 border-bottom pb-2 pt-2 ps-3"
          : "border-200 border-md-200 border-bottom pb-2 pt-2 ps-3",
      totalGraphKey: "femaleOrdersSum",
      newGraphKey: "femaleNewOrderSum",
      repeatGraphKey: "femaleRepeatOrderSum",
      totalCountKey: "femaleOrdersCount",
      newCountKey: "femaleNewOrdersCount",
      repeatCountKey: "femaleRepeatOrderCount",
      // graphKey: "femaleOrdersSum",
      // countKey: "femaleOrdersCount",
      // New order
      newAmount: amount(totalNewFemaleTodaySums),
      newSubAmount: subAmount(totalNewFemaleYesterdaySums),
      newPercent: calculatePercentage(
        totalNewFemaleTodaySums,
        totalNewFemaleYesterdaySums
      ),
      // repeat order
      repeatAmount: amount(totalRepeatFemaleTodaySums),
      repeatSubAmount: subAmount(totalRepeatFemaleYesterdaySums),
      repeatPercent: calculatePercentage(
        totalRepeatFemaleTodaySums,
        totalRepeatFemaleYesterdaySums
      ),

      // Order  count here for female
      totalCount: amount(totalFemaleTodayCountSum),
      totalSubCount: subAmount(totalFemaleYesterdayCountSum),
      type: "standard",
      totalPercent: calculatePercentage(
        totalFemaleTodayCountSum,
        totalFemaleYesterdayCountSum
      ),
      // new order
      newCount: amount(totalFemaleNewTodayCount),
      newSubCount: subAmount(totalNewFemaleYesterdayCount),
      newPercentCount: calculatePercentage(
        totalFemaleNewTodayCount,
        totalNewFemaleYesterdayCount
      ),
      // Repeat
      repeatCount: amount(totalFemaleRepeatTodayCount),
      repeatSubCount: subAmount(totalFemaleRepeatYesterdayCount),
      repeatPercentCount: calculatePercentage(
        totalFemaleRepeatTodayCount,
        totalFemaleRepeatYesterdayCount
      ),
      newFlag: true,
    },
  ];

  const loading = loadingMap[selectedTab];

  return (
    <div className="h-100">
      <CardDiv
        title={
          <div className="d-flex justify-content-between">
            <div className="d-flex gap-1">
              <div
                className={
                  selectedTab == "sales"
                    ? "text-white  border p-1 rounded border-primary bg-primary cursor-pointer mt-1"
                    : "border p-1 rounded  cursor-pointer mt-1 border-primary"
                }
                onClick={() => handleTab("sales")}
              >
                Sales Data
              </div>
              <div
                className={
                  selectedTab == "cancel"
                    ? "text-white cursor-pointer border p-1 bg-primary rounded border-primary mt-1"
                    : "border p-1 rounded cursor-pointer mt-1 border-primary"
                }
                onClick={() => handleTab("cancel")}
              >
                cancel Data
              </div>
              <div
                className={
                  selectedTab == "rto"
                    ? "text-white cursor-pointer border p-1 bg-primary rounded border-primary mt-1"
                    : "border p-1 rounded cursor-pointer mt-1 border-primary"
                }
                onClick={() => handleTab("rto")}
              >
                RTO Data
              </div>
            </div>
            <div className="d-flex gap-2">
              <DatePicker
                selected={compStartDate}
                onChange={(date) => setCompStartDate(date)}
                formatWeekDay={(day) => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select previous Date"
                maxDate={endLastDate}
              />
              <DatePicker
                selected={endLastDate}
                onChange={(date) => setEndDate(date)}
                formatWeekDay={(day) => day.slice(0, 3)}
                className="form-control"
                placeholderText="Select current Date"
                maxDate={new Date()}
                minDate={compStartDate}
              />
              <button className="btn btn-primary" onClick={handleSubmit}>
                Submit
              </button>
              <button className="btn btn-primary" onClick={handleClear}>
                Clear
              </button>
            </div>
          </div>
        }
        component={
          <div>
            {loading ? (
              fourPlaceHolder()
            ) : (
              <div className="mt-n2">
                <div>
                  <FinancialData
                    data={saleItems}
                    setSelectedGraphKey={setSelectedGraphKey}
                    setSelectedCountKey={setSelectedCountKey}
                    selectedGraphKey={selectedGraphKey}
                  />
                  {/* <FinancialOrderData
                    data={saleOrderItems}
                    setSelectedGraphKey={setSelectedGraphKey}
                    setSelectedCountKey={setSelectedCountKey}
                  /> */}
                </div>

                <div className="d-flex flex-column gap-3 card  p-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <Flex className="flex-wrap gap-2 gap-md-3 ps-5">
                      <Form.Check
                        type="checkbox"
                        id="web_shopify"
                        className="mb-0 d-flex"
                      >
                        <Form.Check.Input
                          type="checkbox"
                          className="form-check-input-primary"
                          onClick={() => handleCheckboxToggle("web_shopify")}
                          checked={checkboxes.web_shopify}
                        />
                        <Form.Check.Label className="ps-2 text-600 mb-0">
                          Web Shopify
                        </Form.Check.Label>
                      </Form.Check>
                      <Form.Check
                        type="checkbox"
                        id="web_native"
                        className="mb-0 d-flex ps-0"
                      >
                        <Form.Check.Input
                          type="checkbox"
                          className="ms-0 form-check-input-warning opacity-75"
                          onClick={() => handleCheckboxToggle("web_native")}
                          checked={checkboxes.web_native}
                        />
                        <Form.Check.Label className="ps-2 text-600 mb-0">
                          Web Native
                        </Form.Check.Label>
                      </Form.Check>
                      <Form.Check
                        type="checkbox"
                        id="crm"
                        className="mb-0 d-flex ps-0"
                      >
                        <Form.Check.Input
                          type="checkbox"
                          className="ms-0 form-check-input-danger opacity-75"
                          onClick={() => handleCheckboxToggle("crm")}
                          checked={checkboxes.crm}
                        />
                        <Form.Check.Label className="ps-2 text-600 mb-0">
                          crm
                        </Form.Check.Label>
                      </Form.Check>
                      {/* <Form.Check
                        type="checkbox"
                        id="app"
                        className="mb-0 d-flex ps-0"
                      >
                        <Form.Check.Input
                          type="checkbox"
                          className="ms-0 form-check-input-info opacity-75"
                          onClick={() => handleCheckboxToggle("app")}
                          checked={checkboxes.app}
                        />
                        <Form.Check.Label className="ps-2 text-600 mb-0">
                          App
                        </Form.Check.Label>
                      </Form.Check> */}
                      <Form.Check
                        type="checkbox"
                        id="app_shopflo"
                        className="mb-0 d-flex ps-0"
                      >
                        <Form.Check.Input
                          type="checkbox"
                          className="ms-0 form-check-input-info opacity-75"
                          onClick={() => handleCheckboxToggle("app_shopflo")}
                          checked={checkboxes.app_shopflo}
                        />
                        <Form.Check.Label className="ps-2 text-600 mb-0">
                          App-Shopflo
                        </Form.Check.Label>
                      </Form.Check>
                      <Form.Check
                        type="checkbox"
                        id="app_juspay"
                        className="mb-0 d-flex ps-0"
                      >
                        <Form.Check.Input
                          type="checkbox"
                          className="ms-0 form-check-input-success opacity-75"
                          onClick={() => handleCheckboxToggle("app_juspay")}
                          checked={checkboxes.app_juspay}
                        />
                        <Form.Check.Label className="ps-2 text-600 mb-0">
                          App-Juspay
                        </Form.Check.Label>
                      </Form.Check>
                    </Flex>
                    <div className="d-flex flex-row gap-4">
                      <Form.Check
                        type="switch"
                        id="checkedSwitch"
                        label="All Charts"
                        value={barGraphFLag}
                        onChange={(event) =>
                          setBarGraphFlag(event.target.checked)
                        }
                      />
                      <Form.Check
                        type="switch"
                        id="checkedSwitch"
                        label="Table"
                        value={tableFlag}
                        onChange={(event) => setTableFlag(event.target.checked)}
                      />
                    </div>
                  </div>
                  <div className="">
                    {(tableFlag || barGraphFLag) ? (
                      tableFlag ? (
                        <FinancialTable
                          financeData={dataMapping[selectedTab]}
                          graphKey={selectedGraphKey}
                          countKey={selectedCountKey}
                          checkboxes={checkboxes}
                        />
                      ) : (
                        <FinancialGraph
                          financeData={dataMapping[selectedTab]}
                          graphKey={selectedGraphKey}
                          countKey={selectedCountKey}
                          checkboxes={checkboxes}
                        />
                      )
                    ) : (
                      <div className="d-flex flex-row gap-3" style={{backgroundColor:"#F9FAFD"}}>
                        <div className="" style={{width:"60%", height:"25rem"}}>
                          <BarGraph
                            financeData={dataMapping[selectedTab]}
                            graphKey={selectedGraphKey}
                            countKey={selectedCountKey}
                            checkboxes={checkboxes}
                          />
                        </div>
                        <div className="d-flex flex-column justify-content-end" style={{width:"40%"}}>
                          <BarGraphColumn
                            totalTodaySums={totalTodaySums}
                            totalYesterdaySums={totalYesterdaySums}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        }
      />
    </div>
  );
}

export default FinancialDashboard;
